var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M21.75 7.84644L21.75 34.7214","stroke":"#51525D","strokeWidth":"2.6875","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M31.4248 27.4053L21.7498 37.2146L11.9404 27.4053","stroke":"#51525D","strokeWidth":"2.6875","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ArrowDown.defaultProps = {"width":"43","height":"43","viewBox":"0 0 43 43","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
